import React, {FC, ReactNode} from "react"
import {omit} from "lodash"
import {Modal as StandardModal} from "react-bootstrap"
import {connect} from "@irati/store"
import {User} from "@irati/types"
import ReduxState from "@irati/store/types/ReduxState"

import ModalHeader, {Props as ModalHeaderProps} from "./components/ModalHeader"
import {ImageModal, Back, ModalInner, Close} from "./styled"

// onHide is now required by react-bootstrap, send empty func
const DEFAULT_ON_HIDE = () => {}

interface Props {
  children: ReactNode,
  isMobile: boolean,
  image?: string,
  alignImageLeft?: boolean,
  imageBackgroundColor?: string,
  user?: User,
  trophy?: object,
  onBack?: () => void,
  onHide: () => void,
  onExited: () => void,
  showClose: boolean,
  useMobileStyling: boolean,
  renderHeader: ({image, user, size, alignLeft, backgroundColor}: ModalHeaderProps) => ReactNode
}

const CreateModal: FC<Props> = ({
  onHide,
  onExited,
  onBack,
  image,
  alignImageLeft,
  imageBackgroundColor,
  user,
  renderHeader,
  trophy,
  children,
  showClose,
  isMobile,
  useMobileStyling,
  ...props
}) => {
  const hasCustomHeader = renderHeader !== ModalHeader
  const hasHeader = image || user || hasCustomHeader

  const Modal = hasHeader ? ImageModal : StandardModal
  const size = isMobile && useMobileStyling ? 90 : 150
  const marginTop = isMobile && useMobileStyling ? 60 : 100

  return (
    <Modal {...omit(props, "dispatch")} onHide={onHide} onExited={onExited} margintop={marginTop}>
      {hasHeader && renderHeader({image, user, size, alignLeft: alignImageLeft, backgroundColor: imageBackgroundColor})}
      <ModalInner>
        {onBack && <Back inline={false} icon="backArrow" onClick={onBack} />}
        {onHide !== DEFAULT_ON_HIDE && showClose && <Close inline={false} onClick={onHide} />}
        {children}
      </ModalInner>
    </Modal>
  )
}

CreateModal.defaultProps = {
  onHide: DEFAULT_ON_HIDE,
  onExited: () => {},
  showClose: true,
  useMobileStyling: true,
  renderHeader: ModalHeader
}

const mapStateToProps = ({mq}: ReduxState) => {
  return {
    isMobile: mq.lessThan.medium
  }
}

CreateModal.Inner = ModalInner

export default connect(mapStateToProps)(CreateModal)
